// extracted by mini-css-extract-plugin
export default {"viewwrapper":"IndividualFileDownloader_viewwrapper__AW0kt","iframeviewer":"IndividualFileDownloader_iframeviewer__cDo6y"};